import Faqs from "../components/Faq";
import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import tiktok from '../assets/icons/tiktok.svg'
import youtube from '../assets/icons/youtube.svg'
import { Link } from "react-router-dom";
import { motion } from "motion/react"
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from 'swiper/modules';



const OilGas = () => {



  return (
    <div className="pt-[104px]">
      <div className="relative">
        <div className="sm:h-[50vh]">
          <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
          <img src={require('../assets/imgs/oilgas.jpg')} alt='hero section background' className='block w-full h-full object-bottom object-cover' />
        </div>
        <div className='top-1/2 left-1/2 z-20 absolute flex flex-col m-auto px-7 w-full md:w-3/4 overflow-hidden text-white -translate-x-1/2 -translate-y-1/2'>
          <motion.h1
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[60px] text-center'>Oil & Gas</motion.h1>
          <motion.p
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className='font-[PlayfairDisplay] font-medium text-[20px] md:text-[20px] text-center'>Get To Know us</motion.p>
        </div>
      </div>
      <div className="mx-auto mt-9 mb-6 px-6 max-w-7xl">
        <div className="flex lg:flex-row flex-col items-center gap-[30px] md:gap-[100px] overflow-hidden">
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="rounded-tr-[90px] rounded-bl-[90px] w-full h-[400px] overflow-hidden">
            <img src={require('../assets/imgs/oil&gas.jpg')} alt='hero section background' className='rounded-tr-[90px] rounded-bl-[90px] w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="flex flex-col gap-4">

            <h1 className="font-[PlayfairDisplay] font-bold text-3xl md:text-4xl">AK-JODEM Oil & Gas</h1>

            <p className="text-lg text-justify">
              At Ak Jodem Limited, our oil & Gas sector is built on reliability, safety, and convenience. We provide high-quality petroleum products tailored to meet the needs of households, businesses, and industries, ensuring uninterrupted energy supply for daily living and commercial operations.

            </p>
            <p className="text-lg text-justify">From cooking gas to fuel solutions, we pride ourselves on offering competitive pricing, prompt delivery, and exceptional customer service. With our efficient doorstep delivery system, clients can enjoy peace of mind knowing their energy needs are met without hassle.
            </p>
            <p className="text-lg text-justify">In addition, our oil & Gas division upholds the highest safety standards and regulatory compliance, ensuring every product delivered is handled with care and professionalism. Whether for home, hospitality, or large-scale consumption, Ak Jodem Limited remains a trusted partner in powering lives and businesses.</p>



            <div className="flex justify-between items-center">
              <Link to="/Contact" className="bg-white hover:bg-[#c08b53] mt-6 lg:mt-0 px-6 py-3 border border-black hover:border-none rounded-lg font-semibold hover:text-white">
                Contact Us
              </Link>
              <div className="flex gap-3">
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.facebook.com/share/1Kbi7WK22q/?mibextid=wwXIfr'><img src={facebook} alt='facebook icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.instagram.com/ak_jodem?igsh=azB3aW43cHdhMnpu'><img src={instagram} alt='instagram icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://www.tiktok.com/@ak.jodem?_t=ZS-8vQHBpiryCu&_r=1'><img src={tiktok} alt='tiktok icon' className="h-[15px]" /></a>
                </div>
                <div className="bg-black p-1 rounded-full">
                  <a href='https://m.youtube.com/@Akjodem'><img src={youtube} alt='youtube icon' className="h-[15px]" /></a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>


      </div>
      <div className="m-auto w-1/2">
        <img src={require('../assets/imgs/oil&gas.jpg')} alt='hero section background' />
      </div>

    </div>
  );
};

export default OilGas;
